import { Box } from '@mui/material';
import { FC } from 'react';

export const BlueBackgroundWrapper: FC = ({ children }) => {
  return (
    <Box
      sx={{
        backgroundColor: 'backgroundBlue.main'
      }}
    >
      <Box py={{ xs: 2, md: 4 }} px={{ xs: 2, md: 4 }}>
        {children}
      </Box>
    </Box>
  );
};
